export default "__VITE_ASSET__CHH_VkZJ__"